import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CardTreinamentosComponent } from './card-treinamentos.component';
import { AppComponent } from 'app/app.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [CardTreinamentosComponent],
  exports:[CardTreinamentosComponent],
  bootstrap:[AppComponent]
})
export class CardTreinamentosModule { }
